import URI from 'urijs'
import { config } from '@/plugins/env.config'
import { decamelizeKeys, camelizeKeys } from 'humps'
import Vue from 'vue'
import axios from 'axios';

async function getSponsorProducts(providerSlug, sponsorSlug, attemptNumber = 1) {
  const getSponsorProductsURI = new URI(config.apiBaseUrl)
  getSponsorProductsURI.segment("medical-catalogs")
  getSponsorProductsURI.segment("v1")
  getSponsorProductsURI.segment("products")
  getSponsorProductsURI.segment("providers")
  getSponsorProductsURI.segment(providerSlug)
  getSponsorProductsURI.segment("outpatient-care")
  getSponsorProductsURI.segment(sponsorSlug)

  try{
    return await Vue.prototype.$http.get(getSponsorProductsURI.toString())
  }catch(error){
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response ? error.response : error
    const status = response.status ? response.status : error.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getSponsorProducts(providerSlug, sponsorSlug, attemptNumber + 1)
    }

    throw error
  }
}

async function getSpecificSponsorProduct(providerSlug, sponsorSlug, productCode, attemptNumber = 1) {
  const getSpecificSponsorProductURI = new URI(config.apiBaseUrl)
  getSpecificSponsorProductURI.segment("medical-catalogs")
  getSpecificSponsorProductURI.segment("v1")
  getSpecificSponsorProductURI.segment("products")
  getSpecificSponsorProductURI.segment("providers")
  getSpecificSponsorProductURI.segment(providerSlug)
  getSpecificSponsorProductURI.segment("outpatient-care")
  getSpecificSponsorProductURI.segment(sponsorSlug)
  getSpecificSponsorProductURI.segment("search")

  getSpecificSponsorProductURI.addSearch("productCode", productCode)

  if(!productCode){
    return null
  }

  try{
    return await Vue.prototype.$http.get(getSpecificSponsorProductURI.toString())
  }catch(error){
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response ? error.response : error
    const status = response.status ? response.status : error.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getSpecificSponsorProduct(providerSlug, sponsorSlug, productCode, attemptNumber + 1)
    }

    throw error
  }
}


function getProducts({ productTypeSlug, productName, countryCode, providerSlugs, sponsorSlug }) {
  
  let providerSlug;
  if (typeof providerSlugs === 'string') {
    providerSlug = providerSlugs;
  } else if (Array.isArray(providerSlugs)) {
    providerSlug = providerSlugs.join(',');
  }

  const searchParams = { productTypeSlug, productName, countryCode };

  if (providerSlug) {
    searchParams.providerSlug = providerSlug;
  }

  if (sponsorSlug) {
    searchParams.sponsorSlug = sponsorSlug;
  }

  const params = decamelizeKeys(searchParams);

  return Vue.prototype.$http.get(`${config.apiBaseUrl}/medical-catalogs/v1/products/search`, { params });
}

function formatProductFields({products}) {
  const camelizedProducts = camelizeKeys(products);
  if (Array.isArray(camelizedProducts)) {
      return camelizedProducts.map(product => {
          return {id: product.id, typeSlug: product.productTypeSlug}
      });
  }

  return [];
}

function getIngredients({ name }) {
  const params = decamelizeKeys({ name })
  return Vue.prototype.$http.get(`${config.apiBaseUrl}/v1/ingredients`, { params } );
}

function getDiagnoses({ name, tag }) {
  const params = decamelizeKeys({ name, tag })
  return Vue.prototype.$http.get(`${config.apiBaseUrl}/medical-catalogs/v1/diagnoses/search`, { params });
}

function getDiagnosesForGuestUser({ name, tag }) {
  const params = decamelizeKeys({ name, tag })
  const headers = {
      Authorization: `Bearer ${localStorage.getItem('clientToken')}`
  }
  return axios.get(`${config.apiBaseUrl}/medical-catalogs/v1/diagnoses/search`, { params, headers });
}

export {
  getSponsorProducts,
  getSpecificSponsorProduct,
  getProducts,
  formatProductFields,
  getIngredients,
  getDiagnoses,
  getDiagnosesForGuestUser
}
